// extracted by mini-css-extract-plugin
export default {"file-drop-zone":"FileUploadProvider-module_file-drop-zone_H0nwQ"};